// src/components/fancy/ScrollSkew.jsx
"use client";
import React from "react";

export default function ScrollSkew({ children, maxSkew = 6, className = "" }) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    let lastY = window.scrollY;
    let raf;

    const loop = () => {
      const y = window.scrollY;
      const vel = y - lastY;               // px/frame
      lastY = y;
      const s = Math.max(-maxSkew, Math.min(maxSkew, vel * 0.1));
      if (ref.current) {
        ref.current.style.transform = `skewY(${(-s).toFixed(2)}deg)`;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [maxSkew]);

  return (
    <div ref={ref} className={`will-change-transform ${className}`}>
      {children}
    </div>
  );
}
